import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { ButtonModule, CopyToClipboardModule, LinkModule, TemplateVariablesModule, VisibleInputModule } from '@platform-frontend/ui-tools';
import { RouterExtensionsModule } from '@platform-frontend/util';
import { TranslocoMarkupModule } from 'ngx-transloco-markup';
import { SaasApiKeyComponent } from './saas-api-key/saas-api-key.component';

@NgModule({
  declarations: [SaasApiKeyComponent],
  imports: [
    ButtonModule,
    CommonModule,
    CopyToClipboardModule,
    LinkModule,
    RouterExtensionsModule,
    RouterModule,
    TemplateVariablesModule,
    TranslocoMarkupModule,
    TranslocoModule,
    VisibleInputModule
  ],
  exports: [SaasApiKeyComponent]
})
export class SaasApiKeyModule {}
